import {ajax_get, ajax_post} from "./index";

// 获取专家组
export const getuserlist = (data) => ajax_post('/expertgrouplist', data);
// 添加专家组
export const addusers = (data) => ajax_post('/expertgroupedit', data);
//分配专家
export const fp = (data) => ajax_get('/expertgroupassign', data);


//省级管理员列表
export const provadminlist = (data) => ajax_post('/provadminlist', data);
//省级管理员编辑
export const provadminedit = (data) => ajax_post('/provadminedit', data);
// 密码重置
export const resetpasssword = (data) => ajax_get('/pwdchg', data);



// 获取专家用户列表
export const getexpertlist = (data) => ajax_post('/expertlist', data);
//添加评估专家账号
export const addspeciallist = (data) => ajax_post('/expertedit', data);
//删除评估专家账号
export const expertdelete = (data) => ajax_get('/expertdelete', data);
//博物馆模糊查询
export const museumnamematch = (data) => ajax_get('/museumnamematch', data);

//获取首页弹框数据 expertmuseumscoredetail
export const expertmuseumscoredetail = (data) => ajax_get('/expertmuseumscoredetail', data);
export const expertmuseumscoredetailnew = (data) => ajax_get('/scoreadjustquery', data);



//普通用户列表
export const normaluserlist = (data) => ajax_post('/userlist', data);
//删除普通用户
export const usernormaldelete = (data) => ajax_get('/userdelete', data);
//增加普通用户
export const normaluseredit = (data) => ajax_post('/useredit', data);

//评分统计列表查询
export const getPftjHandler = (data) => ajax_post('/scorestat', data);

//查询评估流程管理
export const pgHandler = (data) => ajax_post('/steplist', data);
//查询评估流程管理编辑
export const pgEditHandler = (data) => ajax_post('/stepedit', data);


//查询评估流程管理
export const pgHandlernew = (data) => ajax_post('/permissionlist', data);
//查询评估流程管理编辑
export const pgEditHandlernew = (data) => ajax_post('/permissionedit', data);




//加分项审核列表
export const specialaddlistHanndler = (data) => ajax_get('/specialaddlist', data);
//加分项审核详情
export const specialadddetailHanndler = (data) => ajax_get('/specialadddetail', data);

//减分项审核列表
export const warningconfirmlistHanndler = (data) => ajax_get('/warningconfirmlist', data);
//减分项审核详情
export const cutscore = (data) => ajax_post('', data);

//减分项审核列表
export const scoreadjustlistHanndler = (data) => ajax_get('/scoreadjustlist', data);
export const scoreadjustlistHanndlernew = (data) => ajax_get('/scoreadjustlist', data);
//减分项审核详情

export const museumqueryHanndler = (data) => ajax_get('/museumquery', data);

export const adminscorequeryHanndler = (data) => ajax_get('/adminscorequery', data);

export const userlistapi = (data) => ajax_get('/userlist', data);
export const profileedit = (data) => ajax_post('/profileedit', data);
export const changephonesapi = (data) => ajax_post('/mobilechg', data);
export const getrankingHandler = (data) => ajax_post('/scoreranking', data);

export const libraryManage = (data) => ajax_get('/museumadminlist', data);
export const addlibraryManage = (data) => ajax_get('/museumadminedit', data);

export const newmuseumqueryHanndler = (data) => ajax_get('dataquery', data);
//填报进度
export const tbjdHanndler = (data) => ajax_get('fillprogress', data);

export const getableHandler = (url,data) => ajax_post(url, data);
